<template>
  <b-card class="mb-5">
    <b-row>
      <b-col md="7">
        <h3 v-if="titleHeader" class="d-flex">{{ $route.name + ' ' + 'on today' }}</h3>
        <h3 v-else>{{$route.name + ' ' + 'on ' + getDateTime(this.addDate)}}</h3>
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
      </b-col>
      <b-col md="5">
        <!-- <b-button @click="doShowModal" v-b-tooltip.hover.top
          title="Export"
          class="mb-2 btn-download float-right ml-2"
          variant="info">
          <font-awesome-icon icon="print"
        />
        </b-button> -->
        <!-- <b-button
          @click="doExportCsv"
          v-b-tooltip.hover.top
          title="Export to CSV"
          variant="info"
          class="mb-2 btn-download float-right"
          ><font-awesome-icon icon="download"
        /></b-button> -->

        <b-button
          @click="doShowModal"
          v-b-tooltip.hover.top
          title="Export Attendance Report"
          variant="success"
          size="md"
          class="mb-2 btn-download float-right"
          ><font-awesome-icon icon="download"
        /></b-button>


        <!-- <b-button
          @click="doExportToPDF"
          v-b-tooltip.hover.top
          title="Export to PDF"
          variant="warning"
          class="mb-2 mr-2 btn-download- float-right"
          >
        <i class="fas fa-file-pdf"></i>
        </b-button> -->
      </b-col>
    </b-row>
    <div class="border-bottom mb-1"></div>
    <b-form v-on:submit.prevent="getDateDataFilter()">
      <b-row>
        <b-col md="12" lg="12">
          <div class="mt-1 mb-2 d-flex">
            <b-col md="4 mb-2">
              <b-input-group>
                <b-form-input
                  id="filter-input"
                  v-model="filter"
                  type="search"
                  placeholder="Search by Name"
                ></b-form-input>
              </b-input-group>
            </b-col>

            <b-col md="4 mb-2 d-flex">
              <date-picker
                v-model="addDate"
                @change="getDateDataFilter"
                type="date"
                placeholder="Input Date to Search"
              ></date-picker>
            </b-col>

            <b-col md="2 mb-2">
              <div class="d-flex">
              <button class="ml-1 btn btn-outline btn-outline-danger" @click="clearFilter()" id="btn-search">
                <font-awesome-icon icon="trash" /> Clear
              </button>
              <button class="ml-1 btn btn-primary" id="btn-search">
                <font-awesome-icon icon="search" /> Filter
              </button>
              </div>
            </b-col>
          </div>
        </b-col>
      </b-row>
    </b-form>
    <b-table
      id="my-table"
      :items="items"
      :busy="isLoading"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      @filtered="onFiltered"
      responsive
      striped
      center
      show-empty
      class="text-left justify-content-center"
    >
    <template v-slot:table-busy>
      <div class="text-center" style="margin: 3% auto;">
        <b-spinner small type="grow" label="Small Spinner"></b-spinner>
        <b-spinner small variant="primary" type="grow" label="Small Spinner"></b-spinner>
        <b-spinner small variant="success" type="grow" label="Small Spinner"></b-spinner>
      </div>
    </template>
      <!-- <template #cell(name)="row">
        {{ row.value.first }} {{ row.value.last }}
        </template> -->

      <template #cell(actions)="row">
        <a
          v-if="row.item.attendanceUuid !==null"
          v-b-tooltip.hover.left
          title="Details"
          class="btn-op icon-info mr-1"
          :href="'/#/attendance' + '/' + row.item.attendanceUuid"
        ></a>
        <a
          v-else
          v-b-tooltip.hover.left
          title="History Employee"
          class="btn-op icon-info mr-1"
          :href="'#/attendance' + '/' + row.item.userProfileUuid + '/histories'"
        ></a>
      </template>
      <template #cell(status)="row">
        <div class="text-center align-items-center">
          <b-badge class="p-1" :variant="getStatusColor(row.item.status)"
            ><span>{{ getStatusName(row.item.status) }}</span></b-badge
          >
        </div>
      </template>
      <template #cell(isOutstation)="row">
        <div class="text-center align-items-center" v-if="row.item.isOutstation === true">
          <font-awesome-icon icon="check" style="margin-top:4px!important;font-size:12px!important;"></font-awesome-icon>
        </div>
        <div v-else>
          <p>-</p>
        </div>
      </template>
      <template #cell(clockIn)="row">
        <div class="text-center">
          {{ row.item.clockIn !== null ? getClockTime(row.item.clockIn, 'HH:mm') : '-' }}
        </div>
      </template>
      <template #cell(clockOut)="row">
        <div class="text-center">
          {{ row.item.clockOut !== null ? getClockTime(row.item.clockOut, 'HH:mm') : '-' }}
        </div>
      </template>
      <template #cell(breakIn)="row">
        <div class="text-center">
          {{ row.item.breakIn !== null ? getClockTime(row.item.breakIn, 'HH:mm') : '-' }}
        </div>
      </template>
      <template #cell(tanggal)="row">
        <div class="text-center">
          {{ row.item.clockIn !== null ? getDateTime(row.item.clockIn, 'YYYY-MM-DD') : '-' }}
        </div>
      </template>
      <template #cell(breakOut)="row">
        <div class="text-center">
          {{ row.item.breakOut !== null ? getClockTime(row.item.breakOut, 'HH:mm') : '-' }}
        </div>
      </template>
      <template #cell(totalMinutesLate)="row">
        <div class="text-center">
          <a v-if="row.item.totalMinutesLate !== null && row.item.totalMinutesLate !==0 && row.item.totalMinutesLate !==undefined ">
          {{ row.item.totalMinutesLate + ' Minutes' }}
          </a>
          <a v-else>-</a>
        </div>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      per-page="perPage"
      class="justify-content-end"
    ></b-pagination>
   <modal-export-monthly ref="modalExportMonthly"></modal-export-monthly>
  </b-card>
</template>

<script>
import ModalExportMonthly from './ModalExportMonthly.vue'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueMonthlyPicker from 'vue-monthly-picker'

export default {
  name: 'attendance-index',
  // eslint-disable-next-line vue/no-unused-components
  components: { DatePicker, ModalExportMonthly, VueMonthlyPicker},

  data() {
    return {
      titleHeader: true,
      isLoading: false,
      apiUrl: {
        attendance: window.AppConfig.apiUrl + 'attendance-report-today',
        exportAttendanceToday: window.AppConfig.apiUrl + 'export-attendance-today',
        exportPdfToday: window.AppConfig.apiUrl + 'export-attendance-pdf'
      },
      perPage: 25,
      currentPage: 1,
      totalRows: 1,
      sortBy: '',
      items: [],
      addDate: new Date(),
      tanggal: '',
      filter: null,
      filterOn: [],
      canShowRoutePath: {
        type: String,
        required: false,
        default: '',
      },
      params: '',
      itemsTwo: [],
      fields: [
        // {
        //   key: 'tanggal',
        //   label: 'Date',
        //   sortable: true,
        //   class: 'text-center',
        // },
        {
          key: 'firstName',
          label: 'Name',
        },
        {
          key: 'status',
          label: 'Status',
          class: 'text-center',
        },
        {
          key: 'isOutstation',
          label: 'Out Station',
          class: 'text-center'
        },
        {
          key: 'clockIn',
          label: 'Clock In',
          class: 'text-center',
        },
        // {
        //   key: 'breakIn',
        //   label: 'Start Break',
        //   sortable: true,
        //   class: 'text-center',
        // },
        // {
        //   key: 'breakOut',
        //   label: 'End Break',
        //   sortable: true,
        //   class: 'text-center',
        // },
        {
          key: 'clockOut',
          label: 'Clock Out',
          class: 'text-center',
        },
        // {
        //   key: 'breakHour',
        //   label: 'Total Break',
        //   sortable: true,
        //   class: 'text-center',
        // },
        {
          key: 'totalMinutesLate',
          label: 'Total Minutes Late',
          class: 'text-center'
        },
        {
          key: 'clockHour',
          label: 'Total Hour',
          class: 'text-center',
        },
        {
          key: 'actions',
          label: 'Detail',
          class: 'text-center',
        },
      ],
      selectedMonth: this.getDateTime(this.min),

      tableFilter: {
        date: null,
        start_time: this.$route.query.start_time,
        start_date: this.$route.query.start_date,
        end_date: this.$route.query.end_date,
        // tanggal: this.$route.query.tanggal
      },
    };
  },

  mounted() {
    this.getAttendanceReportToday();
    this.getStatusColor();
    this.getStatusName();
    this.getClockTime();
    this.getDateTime();
    // this.getAttendanceReportToday();
  },

  watch: {
    // addDate() {
    //   console.log(this.addDate);
    // },
  },

  methods: {
    /* get data from api */
    getAttendanceReportToday() {
      this.isLoading = true
      const todays = this.$moment();
      this.$http
        .get(this.apiUrl.attendance + '?date=' + this.$moment(todays).format('YYYY-MM-DD'))
        .then((resp) => {
          this.items = resp.data;
          this.tanggal = resp.data.clockIn;
          this.totalRows = resp.data.length;
        });
        setTimeout(()=>{
          this.isLoading = false
        }, 1500)
    },

    /** export report today */
    doExportCsv() {
      let url =
        this.apiUrl.exportAttendanceToday +
        '?token=' +
        this.$store.getters['account/tokens'].access_token;
      if (
        this.$moment(this.addDate).format('YYYY-MM-DD') !== undefined &&
        this.$moment(this.addDate).format('YYYY-MM-DD') !== null
      ) {
        url += '&date=' + this.$moment(this.addDate).format('YYYY-MM-DD');
      }
      window.open(url);
    },

   /** export report pdf */
    doExportToPDF(){
      let url = this.apiUrl.exportPdfToday + '?token=' + this.$store.getters['account/tokens'].access_token;
       if (
        this.$moment(this.addDate).format('YYYY-MM-DD') !== undefined &&
        this.$moment(this.addDate).format('YYYY-MM-DD') !== null
      ) {
        url += '&date=' + this.$moment(this.addDate).format('YYYY-MM-DD');
      }
      window.open(url);
    },

    doShowModal(row) {
      this.$refs.modalExportMonthly.showModal(row);
    },

    //get data with date params
    getDateDataFilter() {
      this.isLoading = true
      this.$http
        .get(this.apiUrl.attendance + '?date=' + this.$moment(this.addDate).format('YYYY-MM-DD'))
        .then((resp) => {
          this.items = resp.data;
          this.titleHeader = false;
        })
        setTimeout(()=>{
          this.isLoading = false;
        }, 1200)
    },

    clearFilter(){
      this.addDate = new Date
      this.filter = null
    },

    /** format date time use momentjs */
    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('DD MMMM YYYY');
      } else {
        return '-';
      }
    },

    /** format clock time use momentjs */
    getClockTime(value) {
      if (value !== null) {
        return this.$moment(value).format('HH:mm');
      } else {
        return '-';
      }
    },

    /* Trigger pagination to update the number of buttons/pages due to filtering */
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    /** format status color use badge from bootstrap vue*/

    getStatusColor(value) {
      switch (value) {
        case 'CLOCK_OUT':
          return 'success';
        case 'CLOCK_IN':
          return 'primary';
        case 'NO_STATUS':
          return 'secondary';
        case 'BREAK':
          return 'warning';
      }
    },

    /** format status name
     * example CLOCK_OUT change be CLOCK OUT
     */

    getStatusName(val) {
      switch (val) {
        case 'CLOCK_OUT':
          return 'CLOCK OUT';
        case 'CLOCK_IN':
          return 'CLOCK IN';
        case 'NO_STATUS':
          return 'NO STATUS';
        case 'BREAK':
          return 'BREAK';
      }
    },
  },
};
</script>

<style scoped>
.fa-check{
  color:#fff;
  font-size: 24px;
  background-color: rgb(5, 151, 5);
  width: 36px;
  height: 18px;
  border-radius: 6px;
  text-align: center;
}
</style>
